<template>
  <div class="pago-en-linea">
    <router-view />
  </div>
</template>

<script>
import axios from "axios";
import { getBaseUrl } from "../../store/actions/ModuloActions";

export default {
  data() {
    return {
      poliza: null,
      datosPago: null,
    };
  },
  mounted() {
    // Verificar si ya existe un token en localStorage
    const token = localStorage.getItem("token");
    //if (token) {
    //  console.log("Token ya existe en localStorage:", token);
    //} else {
    //  console.log("No hay token, iniciando login...");
    this.realizarLogin();
    //}
  },
  methods: {
    async realizarLogin() {
      // Usuario y contraseña hardcodeados
      const usuarioHardcoded = {
        userName: "900566",
        password: "566",
      };

      try {
        // Usamos la baseURL definida en ModuloActions
        const url = `${getBaseUrl()}security/api/Login`;

        const response = await axios.post(url, usuarioHardcoded, {
          headers: {
            "Content-Type": "application/json",
            XAPPID: "F827FE82207B214D85FB0C8856B1BCB411D4",
          },
        });

        if (response.status === 200 && response.data.flag) {
          // Guardar el token y otros datos en localStorage
          const token = response.data.data.tokenId;
          localStorage.setItem("token", token);
          //localStorage.setItem("profileId", response.data.data.userId);
        } else {
          console.error("Error en el login:", response.data.errorMessage);
        }
      } catch (error) {
        console.error("Error en la solicitud de login:", error);
      }
    },
    actualizarPoliza(data) {
      this.poliza = data;
    },
    actualizarDatosPago(data) {
      this.datosPago = data;
    },
  },
};
</script>

<style>
.pago-en-linea {
  padding: 20px;
}
</style>
